import { axiosCore } from './http-core-service';
import { HoldingDto } from './dtos/holding.dto';
import { TerritoryOutlineDto } from './dtos/territory-outline.dto';

/**
 * Récupération coordonées des patrimoines.
 * @param mandateId identifiant du mandat
 */
export const getHoldings = async (mandateId: string): Promise<Array<HoldingDto>> => {
    // Récupération du doc selon le mandat
    const response = await axiosCore.get(`/api/maps/mandate/${mandateId}/holdings`);
    return response.data;
};

/**
 * Récupération du contour du territoire d'un mandat territoire.
 * @param mandateId identifiant du mandat
 */
export const getTerritoryOutline = async (mandateId: string): Promise<TerritoryOutlineDto> => {
    const response = await axiosCore.get(`/api/maps/mandate/${mandateId}/territory-outline`);
    return response.data;
};
